import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';

import ClinicianGroupForm from './ClinicianGroupForm';
import WarningSidePanel from '../../common/WarningSidePanel/WarningSidePanel';
import LoadingPageText from '../../common/Loading/LoadingPageText';

import { ClinicianGroupType } from '../../../enums/clinicianGroupType';
import { useFetchClinicianGroups } from '../../../actions/areas/clinicianGroups/fetchClinicianGroups';
import { tableSettings } from './groupsTableSettings';
import { eventHandlers } from './clinicianGroupsHandler';
import { getDateForApi } from '../../../utils/dates';

export default function ClinicianGroupContent({ orgUnitId, validFromDate, validToDate, clinicianGroupType }) {
  const [state, setState] = useState({
    forceReload: false,
    currentPage: 1,
    pageSize: 15,
    clinicianGroupWithDefaultValues: {},
    openClinicianGroupPanel: false,
    openWarningSidePanel: false,
    sortColumn: 'Id',
    sortDirection: 'desc',
    errorMsg: null,
  });

  const model = {
    orgUnitId,
    clinicianGroupType,
    validFromDate: getDateForApi(validFromDate),
    validToDate: getDateForApi(validToDate),
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };
  const { data: clinicianGroupsData, isDataLoading, auth, isUpdateTriggered } = useFetchClinicianGroups(
    model,
    state.forceReload,
  );

  const events = eventHandlers(state, setState, auth);
  const settings = tableSettings({
    count: clinicianGroupsData.totalCount,
    page: clinicianGroupsData.currentPage - 1,
    pageSize: clinicianGroupsData.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isUpdateTriggered,
    activeOnly: clinicianGroupType === ClinicianGroupType.Active,
  });

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>Wait a moment while we gather Clinician pairings info...</LoadingPageText>
    );

  const props = {
    clinicianGroup: state.clinicianGroupWithDefaultValues,
    events,
    errorMsg: state.errorMsg,
  };

  return (
    <div className="page-content-wrapper">
      <MUIDataTable
        title={settings.name}
        data={clinicianGroupsData.mappedClinicianGroups}
        columns={settings.columns}
        options={settings.options}
      />
      {state.openClinicianGroupPanel && <ClinicianGroupForm props={props} />}
      {state.openWarningSidePanel && (
        <WarningSidePanel
          events={events}
          warningMessage={events.locale.getMsg('warningMessageDisable')}
          errorMsg={state.errorMsg}
        />
      )}
    </div>
  );
}
